import { FaberPolicyStatus } from 'ui/components/tuition/enums';

/** Map Sirius membership_status (lowercase) to FaberPolicyStatus for shared tuition UI. */
export const mapTuitionImportMembershipStatus = (membershipStatus: string): FaberPolicyStatus => {
  switch (membershipStatus.toLowerCase()) {
    case 'active':
      return FaberPolicyStatus.Active;
    case 'preactive':
      return FaberPolicyStatus.Preactive;
    case 'cancelled':
    case 'pre-cancelled':
      return FaberPolicyStatus.Cancelled;
    case 'expired':
      return FaberPolicyStatus.Expired;
    case 'suspended':
      return FaberPolicyStatus.PermSuspended;
    case 'inactive':
      return FaberPolicyStatus.Inactive;
    default:
      return FaberPolicyStatus.Pending;
  }
};

export const isTuitionImportActiveOrPreactive = (membershipStatus: string): boolean => {
  const status = membershipStatus.toLowerCase();
  return status === 'active' || status === 'preactive';
};

export const tuitionImportCoveragePercent = (productRate: number): number => Math.round(productRate * 100);

export const USC_SCHOOL_NAME = 'University of Southern California';

export const isUscTuitionImportClaim = (schoolName: string): boolean => schoolName === USC_SCHOOL_NAME;
